/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Správce spuštění pro standardní webové technologie.
 * @implements {StartupManager}
 */
class WebStartupManager {
  /** @inheritdoc */
  destroy() {
    // Prázdná metoda pro splnění rozhraní.
  }

  /** @inheritdoc */
  start() {
    // Prázná metoda pro splnění rozhraní.
    return Promise.resolve();
  }
}

export default WebStartupManager;
